interface ProductSizeSelectorProps {
  enabledSizes: any[];
  selectedSize: string;
  onSizeChange: (size: string) => void;
}

export const ProductSizeSelector = ({ 
  enabledSizes, 
  selectedSize, 
  onSizeChange 
}: ProductSizeSelectorProps) => {
  if (enabledSizes.length === 0) return null;

  return (
    <div>
      <h3 className="font-semibold text-gray-900 mb-3">Size</h3>
      <div className="flex flex-wrap gap-2">
        {enabledSizes.map((size) => (
          <button
            key={size.id}
            onClick={() => onSizeChange(size.id)}
            className={`px-4 py-2 border rounded-lg transition-colors ${
              selectedSize === size.id
                ? 'border-primary bg-primary text-white'
                : 'border-gray-300 hover:border-primary'
            }`}
          >
            {size.name}
            {size.priceModifier && size.priceModifier > 0 && (
              <span className="ml-1 text-sm">+₹{size.priceModifier}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};